import type { FC } from 'react'

import { ReferralLink } from '@pages/IntroducingBroker/Dashboard/ReferralLink/ReferralLink'

import { useIBLink } from '@hooks/useIBLink'
import { useIBReferralCodes } from '@hooks/useIBReferralCodes'

export const ReferralLinkWidget: FC = () => {
  const { ibCode, mtCode, isLoading: isLoadingReferralCodes } = useIBReferralCodes()
  const {
    ibLink,
    mtLink,
    isLoading: isLoadingIBLinks,
    fetchShortenedIBLink,
  } = useIBLink(ibCode, mtCode)

  return (
    <ReferralLink
      isLoading={isLoadingReferralCodes || isLoadingIBLinks}
      ibCode={ibCode}
      ibLink={ibLink}
      mtLink={mtLink}
      mtCode={mtCode}
      fetchShortenedIBLink={fetchShortenedIBLink}
    />
  )
}
